import React from 'react';
import content from '../../../../content/main.archie';
import ShipChart from '../ShipChart/ShipChart.jsx';
import TrafficChart from '../TrafficChart/TrafficChart.jsx';
import Inset from '../../Inset/Inset.jsx';
import SubInset from '../../SubInset/SubInset.jsx';
import {contentToText} from '../../../utils/helpers.jsx';
import Markdown from 'react-remarkable';

export default class Intro extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            tcheight: 370
        }
    }
    
    componentDidMount() {
        this.handleChangeWidth();
    }
    componentDidUpdate(oldprops,oldstate,oldcontext) {
        if(oldcontext.winWidth != this.context.winWidth) {
            this.handleChangeWidth();
        }    
    }
    handleChangeWidth() {
        let shipchartheight = this.refs.shipchart.getBoundingClientRect().height;
        if(shipchartheight!=this.state.tcheight) {
            this.setState({tcheight:Math.min(Math.max(shipchartheight,323),387)});
        }     
    }
    render() {
        let props = this.props;   
        return <div className="container body-text">
            <div className="section intro">
                <div className="row">
                    <div className="col l8 push-l2">
                        <h3>The Age of Shipping</h3>
                        <Markdown>
                            {contentToText(content['intro'],{})}
                        </Markdown>
                    </div>
                </div>
                <Inset hed="Cargo Boom" dek={<span>Larger ships are shipping more cargo each year, especially in Asia.<br/>All values are in TEU (twenty foot equivalent units) = number of standard 6x2.4x2.6 meter containers.</span>} source='Sources: Adapted with permission from "The Geography of Transport Systems" by Jean-Paul Rodrigue (capacities); World Bank (traffic)' notes={[]}>
                    <div className="section">
                        <div className="row">
                            <div className="col m6 s12">
                                
                                <SubInset hed="The evolution of container ships">
                                    <div ref="shipchart">
                                        <ShipChart/>
                                    </div>
                                </SubInset>
                                
                            </div>
                            <div className="col m6 s12">
                                <SubInset hed="Container port traffic by region, in millions of TEU">
                                    <TrafficChart height={this.state.tcheight}/>
                                </SubInset>
                            </div>
                        </div>
                    </div>
                </Inset>
            </div>
        </div>
    }
    
}

Intro.contextTypes = {
    winWidth: React.PropTypes.number.isRequired
};


// WEBPACK FOOTER //
// ./src/js/components/special/Intro/Intro.jsx